"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _deepmerge = _interopRequireDefault(require("deepmerge"));

var _i18n = require("../i18n");

var _reactI18next = require("react-i18next");

var _coamClient = require("coam-client");

var _reactComponents = require("@cimpress/react-components");

require("../styles/UsersTable.css");

var _UserRow = _interopRequireDefault(require("./UserRow"));

var _Loading = _interopRequireDefault(require("./common/Loading"));

var _ErrorInfo = _interopRequireDefault(require("./common/ErrorInfo"));

var _UserForm = _interopRequireDefault(require("./UserForm"));

var _reactStreamlineIcons = require("@cimpress-technology/react-streamline-icons");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var atob = require('atob');

function getSubFromJWT(jwt) {
  try {
    return JSON.parse(atob(jwt.split('.')[1])).sub;
  } catch (e) {
    return null;
  }
}

var UsersTable =
/*#__PURE__*/
function (_React$Component) {
  _inherits(UsersTable, _React$Component);

  function UsersTable(props) {
    var _this;

    _classCallCheck(this, UsersTable);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(UsersTable).call(this, props));
    _this.state = {
      showAdmins: _this.props.showAdminsOnly,
      addUserEnabled: true,
      editUserRolesModalOpen: false,
      editUser: undefined
    };
    return _this;
  }

  _createClass(UsersTable, [{
    key: "tt",
    value: function tt(key) {
      var _this$props = this.props,
          t = _this$props.t,
          language = _this$props.language;

      if (language.length > 2) {
        language = language.substr(0, 2);
      }

      return t(key, {
        lng: language
      });
    }
  }, {
    key: "executeRequest",
    value: function executeRequest(promise, caption, stateVar) {
      var _this2 = this;

      var preformatData = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : undefined;
      this.setState({
        isExecutingRequest: true,
        executingRequestError: undefined,
        executingRequestCaption: caption
      });
      return promise.then(function (response) {
        var state = {
          isExecutingRequest: false,
          executingRequestError: undefined
        };

        if (stateVar) {
          state[stateVar] = preformatData ? preformatData(response) : response;
        }

        _this2.setState(state);
      }).catch(function (error) {
        if (error.response && error.response.status === 403) {
          _this2.setState({
            isExecutingRequest: false,
            executingRequestError: {
              message: _this2.tt('error_not_enough_access_rights')
            }
          });
        } else {
          _this2.setState({
            isExecutingRequest: false,
            executingRequestError: error
          });
        }
      });
    }
  }, {
    key: "sortMembers",
    value: function sortMembers(groupInfo) {
      var members = groupInfo.members.sort(function (a, b) {
        if (a.profile && b.profile) {
          return a.profile.name.localeCompare(b.profile.name);
        }

        if (a.profile) {
          return -1;
        }

        if (b.profile) {
          return 1;
        }

        return a.principal.localeCompare(b.principal);
      });
      groupInfo.members = members;
      return groupInfo;
    }
  }, {
    key: "fetchGroupInfo",
    value: function fetchGroupInfo() {
      return Promise.all([this.executeRequest((0, _coamClient.getGroupInfo)(this.props.accessToken, this.props.groupUrl), this.tt('loading_group_information'), 'groupInfo', this.sortMembers), this.checkIfSearchingForUsersWouldWork(), this.checkIfGroup56()]);
    }
  }, {
    key: "checkIfGroup56",
    value: function checkIfGroup56() {
      var _this3 = this;

      (0, _coamClient.group56)(this.props.accessToken, this.currentUserSub).then(function (g56) {
        _this3.setState({
          g56: g56
        });
      }).catch(function (e) {
        _this3.setState({
          g56: false
        });
      });
    }
  }, {
    key: "checkIfSearchingForUsersWouldWork",
    value: function checkIfSearchingForUsersWouldWork() {
      var _this4 = this;

      (0, _coamClient.findPrincipals)(this.props.accessToken, 'dummy').then(function () {
        _this4.setState({
          addUserEnabled: true
        });
      }).catch(function (e) {
        if (e.response && e.response.status === 403) {
          _this4.setState({
            addUserEnabled: false
          });
        }
      });
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (prevProps.accessToken !== this.props.accessToken && this.props.accessToken || prevProps.groupUrl !== this.props.groupUrl && this.props.groupUrl) {
        this.currentUserSub = getSubFromJWT(this.props.accessToken);
        this.fetchGroupInfo();
      }

      if (prevProps.showAdminsOnly !== this.props.showAdminsOnly) {
        this.setState({
          showAdmins: this.props.showAdminsOnly
        });
      }
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      if (!this.props.accessToken) {
        return;
      }

      this.currentUserSub = getSubFromJWT(this.props.accessToken);
      this.fetchGroupInfo();
    }
  }, {
    key: "onDeleteUser",
    value: function onDeleteUser(user) {
      var _this5 = this;

      var sub = user.principal || user.user_id;
      var newGroupInfo = (0, _deepmerge.default)(this.state.groupInfo, {});
      this.executeRequest((0, _coamClient.removeGroupMember)(this.props.accessToken, this.state.groupInfo.id, sub).then(function (newData) {
        newGroupInfo.members = newGroupInfo.members.filter(function (x) {
          return x.principal !== sub;
        });

        _this5.setState({
          groupInfo: newGroupInfo
        });
      }), this.tt('deleting_user'));
    }
  }, {
    key: "getMemberBySub",
    value: function getMemberBySub(members, sub) {
      var m = members.find(function (nm) {
        return nm.principal === sub;
      });

      if (!m) {
        members.forEach(function (nm) {
          var p = (nm.profiles || []).find(function (a) {
            return a.user_id === sub;
          });

          if (p) {
            m = nm;
          }
        });
      }

      return m;
    }
  }, {
    key: "onAddOrEditUser",
    value: function onAddOrEditUser(user, rolesChanges, isAdmin) {
      var _this6 = this;

      var sub = user.principal || user.canonical_principal || user.user_id;

      if (!sub) {
        sub = Array.isArray(user.profiles) && user.profiles.length > 0 ? user.profiles[0].user_id : null;
      }

      var newGroupInfo = (0, _deepmerge.default)(this.state.groupInfo, {});
      this.executeRequest((0, _coamClient.addGroupMember)(this.props.accessToken, this.state.groupInfo.id, sub, isAdmin).then(function (newData) {
        var newMember = _this6.getMemberBySub(newData.members, sub);

        if (!_this6.getMemberBySub(newGroupInfo.members, sub)) {
          newGroupInfo.members.push(newMember);
        }

        return Promise.resolve();
      }).then(function () {
        return (0, _coamClient.modifyUserRoles)(_this6.props.accessToken, _this6.state.groupInfo.id, sub, rolesChanges);
      }).then(function (newData) {
        var newMember = _this6.getMemberBySub(newGroupInfo.members, sub);

        newMember.roles = newData.roles;
        newMember.is_admin = isAdmin;
        newMember.profiles = user.profiles || (user.profile ? [user.profile] : undefined) || user;

        _this6.setState({
          groupInfo: newGroupInfo
        });
      }), this.tt('adding_or_modifying_user'));
    }
  }, {
    key: "currentUserMember",
    value: function currentUserMember() {
      var _this7 = this;

      if (!this.state.groupInfo) {
        return false;
      }

      var member = this.state.groupInfo.members.find(function (x) {
        return x.principal === _this7.currentUserSub;
      });

      if (!member) {
        this.state.groupInfo.members.forEach(function (m) {
          var matchingProfile = (m.profiles || []).find(function (p) {
            return p.user_id === _this7.currentUserSub;
          });

          if (matchingProfile) {
            member = m;
          }
        });
      }

      return member;
    }
  }, {
    key: "currentUserIsAdmin",
    value: function currentUserIsAdmin() {
      var member = this.currentUserMember();
      return member && member.is_admin === true;
    }
  }, {
    key: "isCurrentUser",
    value: function isCurrentUser(m) {
      var _this8 = this;

      if (m.principal === this.currentUserSub) {
        return true;
      }

      var p = (m.profiles ? m.profiles : []).find(function (p) {
        return p.user_id === _this8.currentUserSub;
      });
      return !!p;
    }
  }, {
    key: "renderUserForm",
    value: function renderUserForm(user) {
      var _this9 = this;

      return _react.default.createElement(_UserForm.default, {
        language: this.props.language,
        accessToken: this.props.accessToken,
        allowedRoles: this.props.allowedRoles,
        mutuallyExclusiveRoles: this.props.mutuallyExclusiveRoles,
        user: user,
        showAvatar: this.props.showAvatar,
        showEmail: this.props.showEmail,
        showEmailAsTooltip: this.props.showEmailAsTooltip,
        showName: this.props.showName,
        onCancel: function onCancel() {
          _this9.setState({
            editUser: undefined,
            isAddingUser: undefined
          });
        },
        onConfirm: function onConfirm(user, changes, isAdmin) {
          _this9.setState({
            editUser: undefined,
            isAddingUser: undefined
          }, function () {
            return _this9.onAddOrEditUser(user, changes, isAdmin);
          });
        }
      });
    }
  }, {
    key: "renderUsers",
    value: function renderUsers() {
      var _this10 = this;

      return this.state.editUser ? this.renderUserForm(this.state.editUser) : _react.default.createElement("div", null, this.props.showAdminsOnlyFilter ? _react.default.createElement("div", null, _react.default.createElement(_reactComponents.Checkbox, {
        style: {
          marginTop: '0px'
        },
        label: this.tt('view_admins_only'),
        checked: this.state.showAdmins,
        onChange: function onChange() {
          return _this10.setState({
            showAdmins: !_this10.state.showAdmins
          });
        }
      })) : null, _react.default.createElement("table", {
        className: "table table-hover"
      }, _react.default.createElement("tbody", null, this.state.groupInfo.members.length == 0 ? _react.default.createElement("em", null, this.tt('no-users')) : null, this.state.groupInfo.members.filter(function (a) {
        return !_this10.state.showAdmins || a.is_admin;
      }).map(function (m, i) {
        var canModify = !_this10.props.readOnly && (_this10.currentUserIsAdmin() || _this10.state.g56);

        return _react.default.createElement(_UserRow.default, {
          language: _this10.props.language,
          key: i,
          user: m,
          showAvatar: _this10.props.showAvatar,
          showEmail: _this10.props.showEmail,
          showEmailAsTooltip: _this10.props.showEmailAsTooltip,
          showName: _this10.props.showName,
          isCurrentUser: _this10.isCurrentUser(m),
          currentUserSub: _this10.currentUserSub,
          allowedRoles: _this10.props.allowedRoles,
          readOnly: !canModify,
          onDeleteUserClick: !canModify ? null : function () {
            return _this10.onDeleteUser(m);
          },
          onEditRolesClick: !canModify ? null : function () {
            return _this10.setState({
              editUser: m
            });
          }
        });
      }))));
    }
  }, {
    key: "renderHeader",
    value: function renderHeader() {
      var _this11 = this;

      var caption = this.tt('header-title-users');

      if (this.state.isAddingUser) {
        caption = this.tt('header-title-add-user');
      }

      if (this.state.editUser) {
        caption = this.tt('header-title-edit-user');
      }

      var addButton = _react.default.createElement(_reactStreamlineIcons.IconAddCircle, {
        size: 'lg',
        color: this.props.readOnly ? _reactComponents.colors.platinum : _reactComponents.colors.shale
      });

      return _react.default.createElement("div", {
        className: 'rcu-header'
      }, _react.default.createElement("div", {
        className: 'row'
      }, _react.default.createElement("div", {
        className: 'col-xs-8'
      }, _react.default.createElement("h5", null, caption, "\xA0", !this.state.isAddingUser && !this.state.editUser ? this.state.addUserEnabled && this.currentUserIsAdmin() || this.state.g56 ? _react.default.createElement(_reactComponents.Tooltip, {
        contents: this.tt('tab_add_user_caption')
      }, _react.default.createElement("span", {
        onClick: function onClick() {
          return _this11.setState({
            isAddingUser: true
          });
        },
        className: 'rcu-icon'
      }, addButton)) : _react.default.createElement(_reactComponents.Tooltip, {
        contents: this.tt('tab_add_user_caption_disabled')
      }, _react.default.createElement("span", {
        className: 'rcu-icon disabled'
      }, addButton)) : null)), _react.default.createElement("div", {
        className: 'col-xs-4'
      }, _react.default.createElement("h5", {
        style: {
          textAlign: 'right'
        }
      }, !this.state.isAddingUser && !this.state.editUser ? _react.default.createElement("span", {
        onClick: function onClick() {
          return _this11.fetchGroupInfo();
        },
        className: 'rcu-icon'
      }, _react.default.createElement(_reactComponents.Tooltip, {
        contents: this.tt('refresh-button-tooltip')
      }, _react.default.createElement(_reactStreamlineIcons.IconSynchronizeArrowsAlt, {
        size: 'lg',
        color: this.props.readOnly ? _reactComponents.colors.platinum : _reactComponents.colors.shale
      }))) : null))));
    }
  }, {
    key: "render",
    value: function render() {
      var _this12 = this;

      if (this.state.isExecutingRequest) {
        return _react.default.createElement(_Loading.default, {
          language: this.props.language,
          message: this.executingRequestCaption
        });
      }

      if (this.state.executingRequestError) {
        return _react.default.createElement(_ErrorInfo.default, {
          language: this.props.language,
          error: this.state.executingRequestError,
          onAcknowledgeClick: function onAcknowledgeClick() {
            return _this12.setState({
              executingRequestError: undefined
            });
          }
        });
      }

      if (!this.props.accessToken || !this.state.groupInfo) {
        return _react.default.createElement(_Loading.default, {
          language: this.props.language,
          message: this.tt('initializing')
        });
      }

      var content = this.renderUsers();

      if (this.state.isAddingUser) {
        content = this.renderUserForm();
      }

      return _react.default.createElement("div", {
        className: 'rcu-component'
      }, _react.default.createElement("div", {
        className: "row"
      }, _react.default.createElement("div", {
        className: "col-sm-12"
      }, this.renderHeader(), content)));
    }
  }]);

  return UsersTable;
}(_react.default.Component);

UsersTable.propTypes = {
  // silence eslint
  t: _propTypes.default.any,
  i18n: _propTypes.default.any,
  language: _propTypes.default.string,
  accessToken: _propTypes.default.string,
  // roles to allow to assign to
  allowedRoles: _propTypes.default.array.isRequired,
  mutuallyExclusiveRoles: _propTypes.default.bool,
  groupUrl: _propTypes.default.string,
  readOnly: _propTypes.default.bool,
  showAdminsOnly: _propTypes.default.bool,
  showAvatar: _propTypes.default.bool,
  showEmail: _propTypes.default.bool,
  showEmailAsTooltip: _propTypes.default.bool,
  showName: _propTypes.default.bool,
  showAdminsOnlyFilter: _propTypes.default.bool,
  showCoamLink: _propTypes.default.bool
};
UsersTable.defaultProps = {
  language: 'en',
  readOnly: false,
  mutuallyExclusiveRoles: false,
  showAdminsOnly: false,
  showAdminsOnlyFilter: true,
  showAvatar: true,
  showEmail: true,
  showEmailAsTooltip: true,
  showName: true
};

var _default = (0, _reactI18next.translate)('translations', {
  i18n: (0, _i18n.getI18nInstance)()
})(UsersTable);

exports.default = _default;